import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigLoginFormComponent } from './uig-login-form.component';
import {
  AuthService,
  CmsConfig,
  ConfigModule,
  CustomLoginGuard,
  GlobalMessageService,
  I18nModule,
  NotAuthGuard,
  UrlModule,
  WindowRef
} from '@spartacus/core';
import {
  FormErrorsModule,
  SpinnerModule
} from '@spartacus/storefront';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UigLoginFormComponentService } from './uig-login-form-component.service';

@NgModule({
  declarations: [UigLoginFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: UigLoginFormComponent,
          guards: [NotAuthGuard,CustomLoginGuard],
          providers: [
            {
              provide: UigLoginFormComponentService,
              useClass: UigLoginFormComponentService,
              deps: [
                AuthService,
                GlobalMessageService,
                WindowRef,
              ],
            },
          ],
        },
      },
    }),
  ]
})
export class UigLoginFormModule { }
